document.addEventListener('DOMContentLoaded', function () {

    const updateBannerHeightAndAlign = () => {
        const bannerSecond = document.querySelectorAll('.banner-second-level');
        const windowWidth = window.innerWidth;

        if (windowWidth > 767) {
            bannerSecond.forEach(banner => {
                const lines = banner.querySelector('.bg-img');
                const img = banner.querySelector('.bg-top img');
                const h1 = banner.querySelector('h1');

                // Update the height of lines based on the image height
                const imgHeight = img.getBoundingClientRect().height;
                lines.style.height = `${imgHeight / 1.71}px`;

                // Get heights and positions for alignment
                const linesBottom = lines.getBoundingClientRect().bottom;
                const h1Bottom = h1.getBoundingClientRect().bottom;

                // Calculate the difference and adjust the margin/padding accordingly
                const offset = linesBottom - h1Bottom;
            });
        }
    };

    // Update height and alignment on load
    setTimeout(function () {
        updateBannerHeightAndAlign();
    }, 200);

    // Update height and alignment on window resize
    window.addEventListener('resize', updateBannerHeightAndAlign);
});

